import { render, staticRenderFns } from "./ChemUCI51LBA4Q16.vue?vue&type=template&id=50e73069&"
import script from "./ChemUCI51LBA4Q16.vue?vue&type=script&lang=js&"
export * from "./ChemUCI51LBA4Q16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
